import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { StyledError, StyledInputContainer } from '../textInput/styles';
import { colors, greyScaleColour } from '@tphglobal/common/theme/style.palette';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

interface Props {
  value?: string;
  onChange?: any;
  error?: string;
  disableErrorMode?: boolean;
  label?: string;
  maxWidth?: string;
}

const PasswordInput: React.FC<Props> = ({
  value,
  onChange,
  error,
  disableErrorMode,
  maxWidth,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const iconStyle = {
    height: '21px',
    width: '21px',
    color: greyScaleColour.grey100,
  };
  return (
    <StyledInputContainer maxWidth={maxWidth}>
      <TextField
        {...props}
        value={value || ''}
        error={disableErrorMode ? undefined : !!error}
        onChange={(event) => {
          if (onChange) {
            onChange(event?.currentTarget?.value);
          }
        }}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={togglePassword}
                onMouseDown={(event) => event.preventDefault()}
              >
                {!showPassword ? (
                  <RemoveRedEyeOutlinedIcon style={iconStyle} />
                ) : (
                  <VisibilityOffOutlinedIcon style={iconStyle} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {!disableErrorMode && error && (
        <StyledError variant="body2">{error}</StyledError>
      )}
    </StyledInputContainer>
  );
};

export default PasswordInput;
